import React from "react";

const Career = () => {
  return (
    <div className="bg-gray-100 py-12">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Page Title */}
        <h1 className="text-3xl font-bold text-gray-800 mb-2">Career</h1>
        <p className="text-gray-600 mb-8">
          Please ensure you enter details in all the fields. Incomplete applications cannot be processed.
        </p>

        {/* Main Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {/* Left Section: Why Choose Us */}
          <div>
            <h2 className="text-xl font-bold text-gray-800 mb-4">Why choose us?</h2>
            <p className="text-gray-700 mb-4">
              At Sanjay K Nathani & Co., we believe in nurturing talent that thrives on intellectual curiosity and a passion for excellence. We foster an environment where individuals are empowered to explore diverse avenues within the realms of Chartered Accountancy.
            </p>
            <p className="text-gray-700 mb-4">
              Our firm is a dynamic hub of services, providing a platform for individuals to delve into:
            </p>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li>Accounting & Bookkeeping</li>
              <li>Comprehensive Audit Solutions</li>
              <li>Financial Advisory</li>
              <li>Taxation, including GST</li>
              <li>Cost Analysis & Management</li>
              <li>Regulatory Compliance Services</li>
            </ul>
            <p className="text-gray-700 mt-4">
              We encourage our team members to identify and cultivate their strengths, allowing them to specialize in areas that align with their interests. This personalized approach ensures continuous growth and a fulfilling professional journey for each individual.
            </p>
          </div>

          {/* Right Section: Job Application Form */}
          <div className="bg-white p-6 rounded-md shadow-md">
            <h3 className="text-lg font-bold text-gray-800 mb-4">Job Application</h3>
            {/* Form */}
            <form>
              {/* Name Field */}
              <div className="mb-4">
                <label htmlFor="name" className="block text-sm font-medium text-gray-700">
                  Your Name *
                </label>
                <input
                  type="text"
                  id="name"
                  placeholder="Enter your name"
                  className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                  required
                />
              </div>

              {/* Email Field */}
              <div className="mb-4">
                <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                  Your Email *
                </label>
                <input
                  type="email"
                  id="email"
                  placeholder="Enter your email"
                  className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                  required
                />
              </div>

              {/* Phone Field */}
              <div className="mb-4">
                <label htmlFor="phone" className="block text-sm font-medium text-gray-700">
                  Your Phone *
                </label>
                <input
                  type="tel"
                  id="phone"
                  placeholder="Enter your phone number"
                  className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                  required
                />
              </div>

              {/* Resume Upload Field */}
              <div className="mb-4">
                <label htmlFor="resume" className="block text-sm font-medium text-gray-700">
                  Upload CV or Resume
                </label>
                <input
                  type="file"
                  id="resume"
                  className="mt-1 block w-full px-4 py-[0.6rem] border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                />
              </div>

              {/* Message Field */}
              <div className="mb-6">
                <label htmlFor="message" className="block text-sm font-medium text-gray-700">
                  Your Message
                </label>
                <textarea
                  id="message"
                  rows={4}
                  placeholder="Enter your message"
                  className="mt-1 block w-full px-4 py-[0.6rem] border border-gray-300 rounded-md focus:ring-blue-500 focus:border-blue-500"
                ></textarea>
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                className="w-full bg-orange-500 text-white py-[0.6rem] rounded-md hover:bg-orange-600 transition duration-200"
              >
                Send Message
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Career;
